import { Field } from 'react-final-form'
import {
  MAX_FLOAT_VALUE,
  MIN_FLOAT_VALUE,
} from 'workflow/CampaignSetup/UiBuilder/UiBuilder.component'

import { PercentageType } from 'common/components/dynamicFields/interfaces'
import FormItem from 'common/components/formItem'
import NumericInput from 'common/components/numericInput'

type Props = {
  name: string
  configuration: PercentageType
  onChange: (value: string) => void
  className?: string
  isDisabled?: boolean
  'data-cy'?: string
  'data-testid'?: string
}

const Rate = ({
  name,
  configuration,
  'data-cy': dataCy,
  'data-testid': dataTestId,
  className,
  isDisabled,
  onChange,
}: Props) => {
  const validateRate = (value: number) => {
    if (!value) {
      return `Please input your ${configuration.label.toLowerCase()}`
    }
  }

  return (
    <Field<number> name={name} validate={validateRate}>
      {({ input, meta }) => (
        <FormItem
          error={meta.touched ? meta.error : undefined}
          htmlFor={input.name}
          label={configuration.label}
          className={className}
        >
          <NumericInput
            data-cy={dataCy}
            data-testid={dataTestId}
            className="updated-component w-full"
            id={input.name}
            placeholder={configuration.placeholder}
            disabled={isDisabled}
            precision={2}
            min={configuration.min || MIN_FLOAT_VALUE}
            max={configuration.max || MAX_FLOAT_VALUE}
            postfix="%"
            onChange={(value) => {
              let stringValue = ''
              if (
                value !== undefined &&
                value >= MIN_FLOAT_VALUE &&
                value <= MAX_FLOAT_VALUE
              ) {
                stringValue = value.toString()
              }
              input.onChange(stringValue)
              onChange(stringValue)
            }}
            value={input.value ? Number(input.value) : undefined}
            onFocus={input.onFocus}
            onBlur={input.onBlur}
          />
        </FormItem>
      )}
    </Field>
  )
}

export default Rate
